import React from "react";
import styled from "styled-components/macro";
import { Delimiter } from "../../models/delimiter";
import { Item } from "../../models/item";
import { ItemList } from "../Item/ItemList";

const MobileProductMenuContainer = styled.div`
    margin-top: 20px;
`;

export const MobileProductMenu = ({ items }: { items: (Item | Delimiter)[] }) => {
    return (
        <MobileProductMenuContainer>
            <ItemList items={items} />
        </MobileProductMenuContainer>
    );
};
